import api from "./api";

const API_URL = "/GeoFence";

const unwrap = (res) => res?.data ?? null;

export const getZones = async () => {
    return unwrap(await api.get(API_URL));
};

export const getZone = async (id) => {
    return unwrap(await api.get(`${API_URL}/${id}`));
};

export const createZone = async (zone) => {
    return unwrap(await api.post(API_URL, {
        name: zone.name,
        centerLat: Number(zone.centerLat),
        centerLng: Number(zone.centerLng),
        radiusMeters: Number(zone.radiusMeters),
    }));
};

export const updateZone = async (id, zone) => {
    return unwrap(await api.put(`${API_URL}/${id}`, {
        name: zone.name,
        centerLat: Number(zone.centerLat),
        centerLng: Number(zone.centerLng),
        radiusMeters: Number(zone.radiusMeters),
    }));
};

export const deleteZone = async (id) => {
    return unwrap(await api.delete(`${API_URL}/${id}`));
};

export const checkPoint = async (lat, lng) => {
    return unwrap(await api.get(`${API_URL}/check`, {
        params: {
            lat: Number(lat),
            lng: Number(lng),
        },
    }));
};

export default {
    getZones,
    getZone,
    createZone,
    updateZone,
    deleteZone,
    checkPoint,
};